import {Box, Typography} from '@ttx/design-system';
import React, {FC} from 'react';

interface IPaymentErrorModel {
  trxHash?: string;
  isMobile: boolean;
}

export const PaymentErrorModel: FC<IPaymentErrorModel> = ({
  trxHash,
  isMobile,
}) => {
  return (
    <>
      <Box 
        display="flex"
        flexDirection="column"
        alignItems="center"
        justifyContent="center"
        width="100%"
        height="100%"
        paddingY={isMobile ? 'four' : 'twelve'}
        paddingX="eight" 
      >
        <Typography color="textDefault" textStyle="h2">
          Uh-oh!
        </Typography>
        <Box mt="s" />
        <Typography color="textDefault" textStyle="s">
          Something went wrong with your purchase. Your NFT is still safe, but
          you might want to give it another shot!
        </Typography>
      </Box>
      <Box paddingTop={isMobile ? 'four' : 'zero'}>
        <>
          {!!trxHash && (
            <Typography color="textLow" textStyle="s">
              #{trxHash}
            </Typography>
          )}
        </>
      </Box>
    </>
  );
};



